module.exports = __webpack_public_path__ + "img/img4.4de9c7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img4.jpg
// module id = 338
// module chunks = 0